var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"container"}},[_c('app-snackbar'),(this.toolbar)?_c('app-toolbar'):_vm._e(),_c('app-tools'),_c('app-view'),_c('app-studio')],1)}
var staticRenderFns = []

export { render, staticRenderFns }